var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1667 8.66667V12C13.1667 12.3667 12.8667 12.6667 12.5 12.6667H4.5C4.13333 12.6667 3.83333 12.3667 3.83333 12V8.66667C3.83333 8.3 3.53333 8 3.16667 8C2.8 8 2.5 8.3 2.5 8.66667V12.6667C2.5 13.4 3.1 14 3.83333 14H13.1667C13.9 14 14.5 13.4 14.5 12.6667V8.66667C14.5 8.3 14.2 8 13.8333 8C13.4667 8 13.1667 8.3 13.1667 8.66667ZM9.16667 8.44667L10.42 7.19333C10.68 6.93333 11.1 6.93333 11.36 7.19333C11.62 7.45333 11.62 7.87333 11.36 8.13333L8.96667 10.5267C8.70667 10.7867 8.28667 10.7867 8.02667 10.5267L5.63333 8.13333C5.37333 7.87333 5.37333 7.45333 5.63333 7.19333C5.89333 6.93333 6.31333 6.93333 6.57333 7.19333L7.83333 8.44667V2.66667C7.83333 2.3 8.13333 2 8.5 2C8.86667 2 9.16667 2.3 9.16667 2.66667V8.44667Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.b8c9ef61.svg";
export { ForwardRef as ReactComponent };